import React from "react";
import starYellow from "/stars/safe/star-4.5.svg";

const RatingLine = () => {
  const heroContent = window.post_template.checkout_v4_product_hero;
  const rating = heroContent.checkout_v4_product_hero_rating;

  return (
    <div className="productHero__ratingLine">
      <div className="productHero__ratingLine__stars" style={{ position: "relative", bottom: "2px" }}>
        <img src={starYellow} alt={window.general_settings?.brand_name} />
      </div>
      <span className="productHero__ratingLine__rating">{rating}</span>
      <div className="productHero__ratingLine__divider"></div>
      <span className="productHero__ratingLine__text">{heroContent.tr_checkout_v4_product_hero_reviews_label}</span>
    </div>
  );
};

export default RatingLine;
